import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "../../stylesheet/activities.css";
import { RiArrowRightUpLine, RiArrowLeftDownLine } from 'react-icons/ri'
import TablePlaceholder from "../../Utils/TablePlaceholder";
import { getAllAppointment } from "../../Utils/localStore";
import ToastContext from "../../context/toasterContex";


const AppointmentRecentActivities = () => {
  const [allAppts, setAllAppts] = useState()
  const { toast } = useContext(ToastContext)
  const getLocalData = async () => {
    let response
    try {
      await getAllAppointment().then(resp => response = resp)
      return setAllAppts(response)
    } catch (error) {
      toast.error(error?.message, { position: toast.POSITION.TOP_CENTER })
      throw new Error(error)
    }
  }
  useEffect(() => {
    getLocalData()
  }, [])
  let tempdata =
    [
      {
        id: 1,
        title: "Addition of inventory -  Emzor Paracetamol",
        body: "Fri Jun 15, 2022  GMT 13:00",
        icon: <RiArrowLeftDownLine />,
        type: "dispersed"

      },
      {
        id: 2,
        title: "Reduction of Inventory - Chemiron  Chloroquine",
        body: "Fri Jun 15, 2022  GMT 13:00",
        icon: <RiArrowRightUpLine />,
        type: "created"

      },
      {
        id: 3,
        title: "Reduction of Inventory - Chemiron  Chloroquine",
        body: "Fri Jun 15, 2022  GMT 13:00",
        icon: <RiArrowRightUpLine />,
        type: "created"

      },
      {
        id: 4,
        title: "Addition of inventory -  Emzor Paracetamol",
        body: "Fri Jun 15, 2022  GMT 13:00",
        icon: <RiArrowLeftDownLine />,
        type: "dispersed"
      },
      {
        id: 5,
        title: "Addition of inventory -  Emzor Paracetamol",
        body: "Fri Jun 15, 2022  GMT 13:00",
        icon: <RiArrowLeftDownLine />,
        type: "dispersed"
      },

    ]
  const navigate = useNavigate()
  return (
    <div className="activities">
      <div className="header_act">
        <h2>Recent Activities</h2>
        <button onClick={() => navigate('/appointments/appointment-report')}>
          <p>View All</p>
        </button>
      </div>
      <div className="relative">
        {allAppts?.length > 0 ? (
          // Render content when data is available
          <ul className="data">
            {allAppts.map((item) =>
              <li key={`${item.id}-${item.title}`}>
                <span className={`activity_icon ${item.status}`}>{item.date}</span>
                <div className="text">
                  <h2>{item.title}</h2>
                  {/* <p> {item.body} </p> */}
                </div>
              </li>
            )}
          </ul>
        ) : (
          <TablePlaceholder lost="You have no record, please create records to view" />
        )}
      </div>
    </div>
  );
};

export default AppointmentRecentActivities;
